import React from "react"

import searchData from "content/search-suggestions.json"

import Icon from "icons"
import {
  SearchModal,
  Header,
  Logo,
  InputWrap,
  Label,
  Input,
  InputFlex,
  Category,
  Item,
} from "./styles"

const Search = ({ onClose }) => (
  <SearchModal onClose={onClose} label="Search">
    <Header>
      <Logo />
      <button type="button" onClick={onClose}>
        <Icon id="close-icon" height={13} width={13} title="Close" />
      </button>
    </Header>
    <InputWrap action="/search">
      <Label htmlFor="search">SEARCH:</Label>
      <InputFlex>
        <Icon id="search-icon" width={34} height={34} title="Search" />
        <Input id="search" name="q" type="text" aria-label="Enter your search" />
        <button type="submit">
          <Icon id="arrow-right-icon" width={35} height={35} />
        </button>
      </InputFlex>
    </InputWrap>
    {searchData.map((c) => (
      <div key={c.category}>
        <Category>{c.category}</Category>
        {c.items.map((i) => (
          <Item key={i.link}>
            <a href={i.link}>{i.title}</a>
          </Item>
        ))}
      </div>
    ))}
  </SearchModal>
)

export default Search
